import React from 'react'
import {
    useShouldShowNormalized,
    useStrikeZoneType,
} from '../../Context/ChartContext.tsx'

export default function ZoneScaleText() {
    const shouldShowNormalized = useShouldShowNormalized()
    const strikeZone = useStrikeZoneType()

    const zoneText =
        strikeZone === 'personal' || !shouldShowNormalized
            ? 'Actual Pitch Height'
            : 'Adjusted for Batter Zone'

    // const zoneX = shouldShowNormalized ? -170 : -145
    const zoneHeight = 16
    return (
        <g transform="translate(10, 520)">
            <g
                className="here"
                transform={`translate(${-16}, ${-zoneHeight + 1})`}
            >
                <rect
                    fill="#f2f2f2"
                    stroke="#666"
                    width="10"
                    height={zoneHeight}
                    strokeWidth="2"
                    strokeDasharray="4 2"
                />
            </g>
            <text
                className="legend"
                fontSize="18"
                textAnchor="start"
                fill="#666"
            >
                {zoneText}
            </text>
        </g>
    )
}
